<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001096') }}</span>
				</div>
			</div>
		</div>

		<sf-data-table
			ref="CmpnOpTable"
			:paging="false"
			:columns="columns"
			:rows="rows"
			:causPartNo="causPartNo"
			:addRowData="addRowData"
			:stripe="false"
			selection
			:scrId="scrId"
			height="380px"
		>
			<!--컬럼에 아이콘 등록방법 시작 -->
			<template v-slot:customRows="slotProps">
				<template v-if="slotProps.column.property === 'opCd'">
					<template v-if="slotProps.row.rowType && slotProps.row.rowType === 'add'">
						<el-input :value="slotProps.row[slotProps.column.property]" maxlength="10" />
						<span class="unit input-icon">
							<i class="icon-sf-search search-icon" @click="onOpCdPopup(slotProps)" :style="searchStye"></i>
						</span>
					</template>
					<template v-else>
						{{ slotProps.row.opCd }}
					</template>
				</template>

				<!--Lts -->
				<!-- <template v-if="slotProps.column.property === 'lts'">
					<div class="position-relative h-100">
						<el-input class="pr-2" :value="slotProps.row[slotProps.column.property]" maxlength="4" @input="val => onChange(val, slotProps)">
						</el-input>
					</div>
				</template> -->
				<!--mtrlCst -->
				<!-- <template v-if="slotProps.column.property === 'mtrlCst'">
					<div class="position-relative h-100">
						<el-input class="pr-2" :value="slotProps.row[slotProps.column.property]" @input="val => onChange(val, slotProps)"> </el-input>
					</div>
				</template> -->
				<!--wags -->
				<template v-if="slotProps.column.property === 'wags'">
					<div class="position-relative h-100">
						<el-input class="pr-2" :value="slotProps.row[slotProps.column.property]" @input="val => onChange(val, slotProps)"> </el-input>
					</div>
				</template>
				<!--incdCst -->
				<template v-if="slotProps.column.property === 'incdCst'">
					<div class="position-relative h-100">
						<el-input class="pr-2" :value="slotProps.row[slotProps.column.property]" @input="val => onChange(val, slotProps)"> </el-input>
					</div>
				</template>
				<!--sumAmt -->
				<template v-if="slotProps.column.property === 'sumAmt'">
					{{ (Math.round(Number(slotProps.row.mtrlCst) + Number(slotProps.row.wags) + Number(slotProps.row.incdCst)) * 100) / 100 }}
				</template>
			</template>

			<!--컬럼에 아이콘 등록방법 끝 -->
			<template v-slot:actionsLeft>
				<sf-button v-if="isButton_(scrId, 'AD')" line icon="square-plue" :onClick="addAction">
					{{ getMessage_('SWCC000007') }}
				</sf-button>
				<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
					{{ getMessage_('SWCC000327') }}
				</sf-button>
				<sf-button v-if="isButton_(scrId, 'CD')" line icon="trash" color="error" :onClick="deleteAction">
					{{ getMessage_('SWCC000328') }}
				</sf-button>
			</template>
		</sf-data-table>
	</div>
</template>

<script>
import * as yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../../store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import qmsUtils from '@/store/qms/api'; //변수관리 값 가져오기

export default {
	props: {
		scrId: { type: String, default: '' },
		sendParam: { type: Object },
		causPartNo: { type: String, default: '' }
	},
	components: {},
	data() {
		return {
			addRowData: {
				rowType: 'add',
				cmpnCd: '', //캠페인번호
				opCd: '', //op코드
				opNm: '', //op코드명
				insnWay: '', //점검방법
				lts: '', //LTS
				mtrlCst: '', //자재비
				wags: '', //공임비
				incdCst: '', //부대비
				causPartNo: this.causPartNo //원인부품번호
			},
			searchStye: {
				//그리드 버튼 스타일 지정
				top: '8px',
				right: '7px'
			},
			opCdInput: '', //opCd 호출시 매개체
			selGridRowIndex: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		selectedRow() {
			const { selectedRow } = this.popupParams;
			return selectedRow;
		},
		rows() {
			return this.opCodeList;
		},
		columns() {
			return [
				{
					label: '* ' + this.getMessage_('QWCC001096'), //op코드
					prop: 'opCd',
					width: '200px',
					headerAlign: 'center',
					sortable: false,
					custom: true
				},
				{
					label: '* ' + this.getMessage_('QWCC001807'), //op코드명
					prop: 'opNm',
					headerAlign: 'center',
					width: '290px',
					sortable: false
				},
				{
					label: '* ' + this.getMessage_('QWCC001099'), //점검방법
					prop: 'insnWay',
					width: '390px',
					sortable: false,
					headerAlign: 'center',
					form: {
						type: 'input',
						maxLength: 160
					}
				},
				{
					label: this.getMessage_('QWCC001100'), //LTS
					prop: 'lts',
					width: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001101'), //자재비
					prop: 'mtrlCst',
					width: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001102'), //공임비
					prop: 'wags',
					width: '150px',
					sortable: false
				},
				{
					label: '* ' + this.getMessage_('QWCC001103'), //부대비
					prop: 'incdCst',
					width: '150px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001104'), //총금액
					prop: 'sumAmt',
					width: '150px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC000001'), //교환부품수량
					prop: 'partCnt',
					minWidth: '150px',
					sortable: false,
					highlight: true,
					clickEvent: this.openModal
				}
			];
		},
		insVali() {
			return yup.object().shape({
				incdCst: yup
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001103')]))
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001103')])), // 은 필수 입력 항목입니다. , 부대비
				// wags: yup
				// 	.string()
				// 	.trim()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001102')]))
				// 	.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001102')])), // 은 필수 입력 항목입니다. , 공임비
				// mtrlCst: yup
				// 	.string()
				// 	.trim()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001101')]))
				// 	.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001101')])), // 은 필수 입력 항목입니다. , 자재비
				// lts: yup
				// 	.string()
				// 	.trim()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001100')]))
				// 	.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001100')])) // 은 필수 입력 항목입니다. , lts
				// 	.matches(/^[.0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC000068'), [this.getMessage_('QWCC001100')])), //숫자만 입력가능합니다
				insnWay: yup
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001099')]))
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001099')])), // 은 필수 입력 항목입니다. , 점검방법
				opNm: yup
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001807')]))
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001807')])), // 은 필수 입력 항목입니다. , op코드
				opCd: yup
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001096')]))
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001096')])) // 은 필수 입력 항목입니다. , op코드
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChange(value, slotProps) {
			const key = slotProps.column.property;
			if (key === 'lts') {
				const arr = value.toString().split('.');
				value = value.replace(/[^.0-9]/g, '');
				if (arr.length > 2) {
					return;
				}
				if (arr.length == 1) {
					if (value.length > 2) {
						value = value.slice(0, 2) + '.';
					}
				}
				if (arr.length == 2) {
					if (arr[1].length > 1) {
						arr[1] = arr[1].slice(0, 1);
					}
					if (arr[0].length > 3) {
						arr[0] = arr[0].slice(0, 3);
					}
					arr[1] = '.' + arr[1];
					value = arr.reduce((a, b) => a + b);
				}
				slotProps.row.lts = value;
			} else if (key === 'incdCst') {
				value = value.replace(/[^-\.0-9]/g, '');
				const arr = value.toString().split('.');
				if (arr.length > 2) {
					return;
				}
				if (arr.length == 1) {
					if (value.length > 8) {
						value = value.slice(0, 8);
					}
				}
				if (arr.length == 2) {
					if (arr[1].length > 2) {
						arr[1] = arr[1].slice(0, 2);
					}
					if (arr[0].length > 8) {
						arr[0] = arr[0].slice(0, 8);
					}
					arr[1] = '.' + arr[1];
					value = arr.reduce((a, b) => a + b);
				}
				slotProps.row[key] = value;
			}
		},
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		//OP코드(공통코드)그리드 팝업 오픈 호출
		onOpCdPopup(param) {
			const causPartNo = this.cmpnMstPopup.causPartNo;
			const commCd = {
				commCdType: 'OP_CD',
				commCd: param.row.opCd,
				causPartNo: causPartNo,
				title: this.getMessage_('QWCC001096')
			};

			this.selGridRowIndex = param.index; //그리드에서 선택한 해당행의 인덱스.
			this.$emit('OpenGridOpPopup', commCd);
		},
		addAction() {
			//행추가
			const cmpnNo = this.cmpnMstPopup.cmpnNo;

			if (cmpnNo == '') {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000007'),
					message: this.getMessage_('QWCC001142')
				}); //캠페인을 먼저 등록해주십시오
			} else {
				const selectedRows = this.$refs.CmpnOpTable.getSelectedRows();

				let addRowData = {
					rowType: 'add',
					cmpnCd: '', //캠페인번호
					opCd: '', //op코드
					opNm: '', //op코드명
					insnWay: '', //점검방법
					lts: '', //LTS
					mtrlCst: '', //자재비
					wags: '', //공임비
					incdCst: '', //부대비
					causPartNo: this.causPartNo //원인부품번호
				};
				this.rows.push(addRowData);
				this.$refs.CmpnOpTable.getTable().toggleRowSelection(addRowData);
			}
		},
		saveAction() {
			//저장
			const cmpnNo = this.cmpnMstPopup.cmpnNo;

			if (cmpnNo == '') {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000103'),
					message: this.getMessage_('QWCC001142')
				}); //캠페인을 먼저 등록해주십시오
			} else {
				const selected = this.$refs.CmpnOpTable.getSelectedRows();

				if (selected.length < 1) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('SWCC000103'),
						message: this.getMessage_('QWCC000914')
					}); //행을 선택해 주세요. / 수정된 데이터가 없습니다.
					return;
				}
				//벨리데이션체크
				try {
					for (let i = 0; i < selected.length; i++) {
						this.insVali.validateSync(selected[i]);

						if (selected[i].causPartNo == null || selected[i].causPartNo == '') {
							selected[i].causPartNo = this.cmpnMstPopup.causPartNo;
						}
					}

					//컨펌창
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
						buttons: [{ title: this.getMessage_('SWCC000278'), clickFn: this.saveOpCd }] //저장
					});
				} catch (error) {
					this.$sf_toast({ type: 'error', message: error.message });
				} finally {
					this.$sf_toggleLoading(false);
				}
			}
		},
		async saveOpCd() {
			this.$sf_toggleLoading(true);

			try {
				const saveRows = this.$refs.CmpnOpTable.getSelectedRows();
				// saveRows.forEach(row => {
				// 	if (row.causPartNo == '') {
				// 		row.causPartNo = this.cmpnMstPopup.causPartNo;
				// 	}
				// });
				const cmpnNo = this.cmpnMstPopup.cmpnNo;
				const params = { cmpnNo: cmpnNo, saveRows: saveRows };

				const { code, messageCd } = await this.saveOpCdList_(params);

				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('Refresh');
				}
				//Table();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		deleteAction() {
			//삭제
			const cmpnNo = this.cmpnMstPopup.cmpnNo;

			let rowN = 0;
			let rowTypeFlg = false;

			for (let i = 0; i < this.rows.length; i++) {
				if (this.rows[i].rowType == 'add') {
					this.rows[i].rowNum = rowN + 1;
					rowN = this.rows[i].rowNum;
				}
			}

			if (cmpnNo == '') {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('QWCC001136'),
					message: this.getMessage_('QWCC001142')
				}); //캠페인을 먼저 등록해주십시오
			} else {
				const selected = this.$refs.CmpnOpTable.getSelectedRows();

				if (selected.length < 1) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('SWCC000103'),
						message: this.getMessage_('QWCC000914')
					}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
					return;
				}

				for (let i = 0; i < this.rows.length; i++) {
					for (let j = 0; j < selected.length; j++) {
						if (this.rows[i].rowNum == selected[j].rowNum && selected[j].rowType !== null) {
							this.rows.splice(i, 1);
							i--;
						} else if (selected[j].rowType == null || selected[j].rowType == '') {
							rowTypeFlg = true;
						}
					}
				}

				if (rowTypeFlg == true) {
					try {
						//컨펌창
						this.$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							title: this.getMessage_('SWCC000108'), //삭제하시겠습니까?
							buttons: [{ title: this.getMessage_('SWCC000107'), clickFn: this.delete }] //삭제
						});
					} catch (error) {
						this.$sf_toast({ type: 'error', message: error.message });
					} finally {
						this.$sf_toggleLoading(false);
					}
				}
			}
		},
		async delete() {
			this.$sf_toggleLoading(true);
			const saveRows = this.$refs.CmpnOpTable.getSelectedRows();
			const cmpnNo = this.cmpnMstPopup.cmpnNo;
			const params = { cmpnNo: cmpnNo, saveRows: saveRows };

			this.deleteOpCdList_(params)
				.then(response => {
					if (response.message != undefined && response.message != null) {
						this.$sf_toast({
							type: response.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.messageCd)
						});
					}
					this.resetSelection();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		resetSelection() {
			//체크박스 해제
			let checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}

			this.$emit('Refresh');
		},
		async openModal(row) {
			const rsltVarValue = await qmsUtils.getVariableValue('pwaEndPartStdCst');

			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: {
					show: true,
					selectedRow: this.getSearchCmpnPartList_(row),
					opCd: row.opCd,
					lts: row.lts,
					mtrlCst: row.mtrlCst,
					stdCst: rsltVarValue.varVal
				}
			});
		},
		searchCmpnPartList(row) {
			try {
				this.$sf_toggleLoading(true);
				this.isLoading = true;

				this.getSearchCmpnPartList_(row);
			} catch (error) {
			} finally {
				this.isLoading = false;
				this.$sf_toggleLoading(false);
			}
			//this.$sf_toggleLoading(true);
			//this.getSearchcmpnPartList__({ cmpnNo,opCd, ...this.taskCommCdPagingInfo, currentPage: 1 }).finally(() => this.$sf_toggleLoading(false));
		}
	},
	watch: {
		sendParam(newValue, oldValue) {
			this.commCd = this.sendParam;
			let dataArr = this.opCodeList.slice();
			let check = false;
			//opCd 중복 체크
			for (let i = 0; i < this.rows.length; i++) {
				if (this.rows[i].opCd == this.commCd.opCd) {
					check = true;
				}
			}
			if (check == false) {
				dataArr[this.selGridRowIndex].opCd = this.commCd.opCd;
				dataArr[this.selGridRowIndex].opNm = this.commCd.opNm;
				dataArr[this.selGridRowIndex].lts = this.commCd.lts;
				dataArr[this.selGridRowIndex].mtrlCst = this.commCd.asCst;
				dataArr[this.selGridRowIndex].wags = this.commCd.wags;
			} else {
				this.$sf_toast({ type: 'error', message: this.getMessage_('SWCC000793') });
			}
		}
	}
};
</script>
